import { render, staticRenderFns } from "./ChatBoxModalSendFile.vue?vue&type=template&id=fb03b862&scoped=true&"
import script from "./ChatBoxModalSendFile.vue?vue&type=script&lang=js&"
export * from "./ChatBoxModalSendFile.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxModalSendFile.vue?vue&type=style&index=0&id=fb03b862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb03b862",
  null
  
)

export default component.exports